module.exports = __webpack_public_path__ + "img/1684205717036-image.jpg.ca4fcbdc.webp";